<template>
    <div class="container">
        <h1>Camera "{{camera['name']}}"</h1>
        <b-tabs position="is-centered" class="block" v-model="activeTab">
            <b-tab-item label="Info">
                <div class="container margin_top_1rem has-text-left">
                    <b-field label="Camera name">
                        <b-input v-model="name" required placeholder="Enter name for camera"></b-input>
                    </b-field>
                    <b-field label="Device for URL provider">
                        <b-select v-model="deviceId">
                            <option v-for="device in deviceList"
                                    :key="device.id"
                                    :value="device.id"
                            >{{device.title}}</option>
                        </b-select>
                    </b-field>
                    <b-field label="Topic for URL provider" v-if="deviceId > 0">
                        <b-select v-model="deviceTopicId">
                            <option v-for="topic in deviceTopicsList"
                                    :key="topic.id"
                                    :value="topic.id"
                            >{{topic.topic}}</option>
                        </b-select>
                    </b-field>
                    <div class="buttons">
                        <b-button type="is-danger-outlined" @click="handleBack">Back</b-button>
                        <b-button type="is-success" :disabled="!changeRecorded()" @click="handleChange">Change
                        </b-button>
                    </div>
                </div>
            </b-tab-item>
            <b-tab-item label="Delete">
                <div class="container margin_top_1rem">
                    <b-button type="is-danger" @click="handleDelete">Delete camera</b-button>
                </div>
            </b-tab-item>
        </b-tabs>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTabs from "buefy/src/components/tabs/Tabs";
  import BTabItem from "buefy/src/components/tabs/TabItem";
  import BField from "buefy/src/components/field/Field";
  import BInput from "buefy/src/components/input/Input";
  import BButton from "buefy/src/components/button/Button";
  import BSelect from "buefy/src/components/select/Select";

  export default {
    name: "screenconfigurecamera",
    components: {
      BSelect,
      BButton,
      BInput,
      BField,
      BTabItem,
      BTabs
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        initialName: '',
        initialDeviceTopicId: 0,
        deviceId: 0,
        deviceTopicId: 0
      };
    },
    computed: {
      ...mapGetters('cameras', ['cameraById', 'cameras']),
      ...mapGetters('devices', ['devices', 'topicsByDeviceId']),
      camera() {
        return this.cameraById(this.$route.params.id);
      },
      deviceList() {
        const ret = [
          {
            id: 0,
            title: 'Choose a device...'
          }
        ];
        this.devices.forEach(device => {
          ret.push({
            ...device,
            title: device.integration_name + ' - ' + device.name
          });
        });

        return ret;
      },
      deviceTopicsList() {
        if (this.deviceId === 0) {
          return [];
        }

        return this.topicsByDeviceId(this.deviceId);
      }
    },
    methods: {
      ...mapActions('cameras', ['modifyCamera', 'removeCamera']),
      changeRecorded() {
        return this.initialName !== this.name || (this.initialDeviceTopicId !== this.deviceTopicId && this.deviceTopicId > 0);
      },
      handleChange() {
        this.modifyCamera({
          id: this.camera.id,
          name: this.name,
          deviceTopicId: this.deviceTopicId
        });
        this.resetFields();
      },
      handleDelete() {
        if (confirm('Are you sure ?')) {
          this.removeCamera(this.camera.id);
          this.handleBack();
        }
      },
      handleBack() {
        this.$router.push('/configure/cameras');
      },
      resetFields() {
        this.initialName = this.name;
        this.initialDeviceTopicId = this.deviceTopicId;
      }
    },
    mounted() {
      this.name = this.camera ? this.camera.name : '';
      this.deviceId = this.camera ? this.camera.device_id : 0;
      this.deviceTopicId = this.camera ? this.camera.device_topic_id : 0;
      this.resetFields();
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }

    .margin_bottom_1rem {
        margin-bottom: 1rem;
    }

    .group_items {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .move {
        cursor: pointer;
    }
</style>